import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { GridModule } from '@progress/kendo-angular-grid';
import { NavigationModule } from '@progress/kendo-angular-navigation';
import { OAuthModule } from 'angular-oauth2-oidc';
import { ApiModule } from 'src/proxy';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { EnvServiceProvider } from './core/deployment/env.service.provider';
import { LoaderModule } from './shared/loader/loader.module';

@NgModule({
  declarations: [AppComponent],
  imports: [BrowserModule, CoreModule, GridModule, BrowserAnimationsModule, DropDownsModule, LoaderModule, DialogsModule, ApiModule, NavigationModule, OAuthModule.forRoot()],
  providers: [EnvServiceProvider],
  bootstrap: [AppComponent],
})
export class AppModule {}
